module.exports = __webpack_public_path__ + "img/组 1@2x.156a98be.png";